import type { ReactNode } from 'react';

import { usePermissions } from '../hooks/use-permissions';
import { NoPermission } from './NoPermission';

interface PermissionGuardProps {
  children: ReactNode;
  fallback?: ReactNode;
  permission?: string;
  permissions?: string[];
  requireAll?: boolean;
}

export function PermissionGuard({
  children,
  fallback,
  permission,
  permissions,
  requireAll = false,
}: PermissionGuardProps) {
  const { can, canAny, canAll } = usePermissions();

  let allowed = false;

  if (permission) {
    allowed = can(permission);
  } else if (permissions) {
    allowed = requireAll ? canAll(...permissions) : canAny(...permissions);
  }

  if (!allowed) {
    return <>{fallback ?? <NoPermission />}</>;
  }

  return <>{children}</>;
}
